/* Masque la section faux-avis "reviews_social" (retirée à la demande) — Claude */
document.addEventListener('DOMContentLoaded',function(){
  var st=document.createElement('style');
  st.textContent='[id*="reviews_social"]{display:none !important}';
  (document.head||document.documentElement).appendChild(st);
});

/* rp-size-units build 2 — in-place EU/US/UK size relabelling on the size buttons — Claude */
(function(){
  // EU (whole) -> [US Men, US Women, UK]. Approximate; fit varies ~1/2 size by brand.
  var MAP={
    "35":["3.5","5","3"],"36":["4","5.5","3.5"],"37":["4.5","6","4"],"38":["5.5","7","5"],
    "39":["6","7.5","5.5"],"40":["7","8.5","6"],"41":["8","9.5","7"],"42":["8.5","10","8"],
    "43":["9.5","11","9"],"44":["10","11.5","9.5"],"45":["11","12.5","10.5"],"46":["12","13.5","11.5"],
    "47":["13","14.5","12"],"48":["13.5","15","12.5"]
  };
  var UNITS=[
    {key:"usm",label:"US M",idx:0},
    {key:"usw",label:"US W",idx:1},
    {key:"eur",label:"EUR",eu:true},
    {key:"uk",label:"UK",idx:2}
  ];
  var DEFAULT="usm", SKEY="rp_size_unit";
  function curUnit(){ try{var v=sessionStorage.getItem(SKEY);if(v)return v;}catch(e){} return DEFAULT; }
  function setUnit(u){ try{sessionStorage.setItem(SKEY,u);}catch(e){} }
  function conv(eu,unit){ var m=MAP[eu]; var uo=null; for(var i=0;i<UNITS.length;i++){if(UNITS[i].key===unit)uo=UNITS[i];} if(!uo)return eu; if(uo.eu||!m)return eu; return m[uo.idx]||eu; }
  var CSS=[
    ".rp-su{display:flex;gap:6px;margin:2px 0 8px;flex-wrap:wrap;align-items:center;flex:0 0 100%;width:100%;grid-column:1/-1}",
    ".rp-su-tab{border:1px solid #dcdcdc;background:#fff;color:#555;font-size:12px;font-weight:700;padding:6px 12px;border-radius:999px;cursor:pointer;line-height:1;transition:.15s;-webkit-tap-highlight-color:transparent}",
    ".rp-su-tab:hover{border-color:#111;color:#111}",
    ".rp-su-tab.rp-on{background:#111;color:#fff;border-color:#111}",
    ".rp-su-hint{font-size:11px;color:#a2a2a2;margin:-2px 0 12px;line-height:1.35;flex:0 0 100%;width:100%;grid-column:1/-1}"
  ].join("");
  function inject(){ if(document.getElementById("rp-su-css"))return; var s=document.createElement("style");s.id="rp-su-css";s.textContent=CSS;(document.head||document.documentElement).appendChild(s); }
  function isSizeLabel(t){ return /size|taille|pointure/i.test(t||""); }
  function sizeFieldsets(vp){
    var out=[];
    vp.querySelectorAll("fieldset, .variant-option").forEach(function(fs){
      var leg=fs.querySelector("legend, .form__label, label");
      var legTxt=leg?leg.textContent:"";
      var spans=fs.querySelectorAll(".variant-option__button-label__text");
      if(!spans.length)return;
      var mappable=0;
      spans.forEach(function(sp){ var eu=(sp.dataset.rpEu||sp.textContent||"").trim(); if(MAP[eu])mappable++; });
      if(isSizeLabel(legTxt) && mappable>=2 && out.indexOf(fs)<0) out.push(fs);
    });
    return out;
  }
  function applyUnit(fs,unit){
    fs.querySelectorAll(".variant-option__button-label__text").forEach(function(sp){
      if(!sp.dataset.rpEu){ var t=(sp.textContent||"").trim(); if(MAP[t]) sp.dataset.rpEu=t; else return; }
      var eu=sp.dataset.rpEu; var val=conv(eu,unit);
      if(sp.textContent.trim()!==val) sp.textContent=val;
      var inp=sp.closest("label")&&sp.closest("label").querySelector("input");
      if(inp){ var al=(unit==="eur")?("EU "+eu):(val+" "+unit.toUpperCase().replace("US","US ").trim()); if(inp.getAttribute("aria-label")!==al) inp.setAttribute("aria-label",al); }
    });
    var bar=fs.querySelector(".rp-su");
    if(bar) bar.querySelectorAll(".rp-su-tab").forEach(function(b){ b.classList.toggle("rp-on", b.dataset.u===unit); });
  }
  function buildBar(fs){
    if(fs.querySelector(".rp-su"))return;
    inject();
    var bar=document.createElement("div"); bar.className="rp-su"; bar.setAttribute("role","group"); bar.setAttribute("aria-label","Size unit");
    UNITS.forEach(function(u){
      var b=document.createElement("button"); b.type="button"; b.className="rp-su-tab"; b.dataset.u=u.key; b.textContent=u.label;
      b.addEventListener("click",function(ev){ ev.preventDefault(); ev.stopPropagation(); setUnit(u.key); applyUnit(fs,u.key); syncAll(u.key); });
      bar.appendChild(b);
    });
    var hint=document.createElement("div"); hint.className="rp-su-hint"; hint.textContent="Switch units — sizes are stored EU. Conversions are approximate (±½ size by brand).";
    var firstBtn=fs.querySelector("label.variant-option__button-label");
    var leg=fs.querySelector("legend, .form__label");
    if(firstBtn){ fs.insertBefore(bar, firstBtn); fs.insertBefore(hint, firstBtn); }
    else if(leg){ leg.parentNode.insertBefore(bar, leg.nextSibling); }
    else { fs.insertBefore(bar, fs.firstChild); }
  }
  var _all=[];
  function syncAll(unit){ _all.forEach(function(fs){ if(document.contains(fs)) applyUnit(fs,unit); }); }
  function build(){
    if(location.pathname.indexOf("/products/")<0)return;
    var vp=document.querySelector("variant-picker");
    if(!vp)return;
    var fss=sizeFieldsets(vp);
    if(!fss.length)return;
    _all=fss;
    var unit=curUnit();
    fss.forEach(function(fs){ buildBar(fs); applyUnit(fs,unit); });
  }
  function boot(){
    build();
    if(window.MutationObserver){
      var sc=false;
      new MutationObserver(function(){ if(sc)return;sc=true;setTimeout(function(){sc=false;build();},220); }).observe(document.documentElement,{childList:true,subtree:true});
    }
    var n=0,iv=setInterval(function(){ build(); if(++n>16)clearInterval(iv); },500);
  }
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);
})();

/* rp-breadcrumbs — fil d'Ariane visible, construit depuis le JSON-LD BreadcrumbList — Claude */
(function(){
  var CSS=".rp-bc{font-size:12px;color:#8a8a8a;margin:10px 0 2px;display:flex;flex-wrap:wrap;gap:4px 7px;align-items:center;line-height:1.5}.rp-bc a{color:#8a8a8a;text-decoration:none}.rp-bc a:hover{color:#111;text-decoration:underline}.rp-bc .rp-bc-sep{color:#ccc}.rp-bc .rp-bc-cur{color:#111;font-weight:600}";
  function inject(){ if(document.getElementById('rp-bc-css'))return; var s=document.createElement('style');s.id='rp-bc-css';s.textContent=CSS;(document.head||document.documentElement).appendChild(s); }
  function getCrumbs(){
    var scripts=document.querySelectorAll('script[type="application/ld+json"]');
    for(var i=0;i<scripts.length;i++){
      try{ var j=JSON.parse(scripts[i].textContent); if(j && j['@type']==='BreadcrumbList' && j.itemListElement){
        return j.itemListElement.slice().sort(function(a,b){return (a.position||0)-(b.position||0);}).map(function(e){return {name:e.name,item:e.item};});
      } }catch(e){}
    }
    return null;
  }
  function build(){
    if(document.getElementById('rp-breadcrumbs'))return;
    if(!/\/(products|collections)\//.test(location.pathname))return;
    var crumbs=getCrumbs();
    if(!crumbs||crumbs.length<2)return;
    var main=document.querySelector('#MainContent')||document.querySelector('main');
    if(!main)return;
    inject();
    var nav=document.createElement('nav');nav.id='rp-breadcrumbs';nav.className='rp-bc';nav.setAttribute('aria-label','Breadcrumb');
    var html='';
    crumbs.forEach(function(c,idx){
      if(idx>0) html+='<span class="rp-bc-sep">/</span>';
      var name=String(c.name||'').replace(/</g,'');
      if(idx===crumbs.length-1) html+='<span class="rp-bc-cur">'+name+'</span>';
      else html+='<a href="'+String(c.item||'#').replace(/"/g,'')+'">'+name+'</a>';
    });
    nav.innerHTML=html;
    main.insertBefore(nav, main.firstChild);
  }
  function boot(){
    build();
    if(window.MutationObserver){var sc=false;new MutationObserver(function(){if(sc)return;sc=true;setTimeout(function(){sc=false;if(!document.getElementById('rp-breadcrumbs'))build();},250);}).observe(document.documentElement,{childList:true,subtree:true});}
    var n=0,iv=setInterval(function(){if(!document.getElementById('rp-breadcrumbs'))build();if(++n>16)clearInterval(iv);},500);
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();
